declare const require: any;
declare const ENV_CONFIG: { [key: string]: any };

import * as _ from 'lodash';
import { SerialDecoders } from 'projects/libs/ui/levero-serial-port/src/lib/decoder/serial-decoders.enum';

export const environment = _.merge({
  production: true,
  appId: 'po-smart',
  appVersion: require('../../package.json').version,
  appDeployment: 'Release',
  appPackage: 'po-smart',
  backendHost: 'https://backend.pumpenoase.at',
  backendPort: 443,
  backendMainHub: '/api',
  backendIPCHub: '/ipc',
  backendIPCGroups: [
    'notification',
    'time-tracking'
  ],
  auth: {
    autoLogin: true, // auto login user if token is still valid
    allowSSO: false, // allow single sign-on
    allowWinLogon: false, // allow logon via username and pw on the domain, if it is false it defaults to "database logon"
    endpoint: '/auth',
    loginRoute: '/login',
    loginSuccessRoute: '/time-tracking/recording',
    profiles: [
      {
        profileId: 'office',
        profileName: 'Büro/Außendienst',
        profileDescription: 'Anwendung wird im Büro oder am Smartphone vom Außendienst verwendet',
        auth: {
          allowSSO: false,
          allowWinLogon: false,
          allowRFID: false,
          allowSerialRFID: false,
          loginSuccessRoute: '/time-tracking/recording',
          showClock: false
        }
      },
      {
        profileId: 'customerService',
        profileName: 'KDD',
        profileDescription: 'Anwendung für KDD Verwalter und Service Techniker',
        auth: {
          allowSSO: false,
          allowWinLogon: false,
          allowRFID: false,
          allowSerialRFID: false,
          loginSuccessRoute: '/customer-service/calendar',
          showClock: false
        }
      },
      {
        profileId: 'terminal',
        profileName: 'Terminal',
        profileDescription: 'Anwendung wird als Terminal für die Zeiterfassung verwendet',
        auth: {
          autoLogin: false, // auto login user if token is still valid
          allowSSO: false, // allow single sign-on
          allowWinLogon: false, // allow logon via username and pw on the domain, if it is false it defaults to "database logon"
          allowRFID: false,
          allowSerialRFID: true,
          serialRFIDOptions: {
            serialDecoder: SerialDecoders.PromagPCR300,
            infoLabel: 'Halte deinen Mitarbeiterausweis über das Lesegerät',
            deviceName: 'Lesegerät',
            // devRFIDTag: '0002173170', // this is for dev mode only! the specified value will be used as RFID tag for auth
            defaultVendorId: 1659
          },
          // devRFIDTag: '0002173170', // this is for dev mode only! the specified value will be used as RFID tag for auth
          autoLogout: 30, // logs out the user automatically after 30 seconds without any user actions
          loginSuccessRoute: '/time-tracking/recording',
          showClock: true
        }
      }
    ]
  },
  report: {
    endpoint: '/report'
  }
}, typeof ENV_CONFIG === 'undefined' ? {} : ENV_CONFIG);
